export function spacing(multiplier: number): string {
    return `${5 * multiplier}px`
}
